<template>
  <div>
    <div
    class="cloak"
    :class="isShow ? 'isShow': 'isHidden'">
      <div class="content">
        <div class="img">
          <img :src="code" alt="">
        </div>
        <div class="word">{{desc}}</div>
        <div class="return-btn" @click="closeCloak">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['isShow', 'code', 'desc'],
  methods: {
    closeCloak () {
      this.$emit('closeCloak')
    }
  }
}
</script>
<style lang='scss' scoped>
@keyframes cloakDisplay {
  from {
    -webkit-clip-path: circle(20vw at 50vw 50vh);
    clip-path: circle(20vw at 50vw 50vh);
  }
  to {
    -webkit-clip-path: circle(100vh at 50vw 50vh);
    clip-path: circle(100vh at  50vw 50vh);
  }
}
.cloak {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000000;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 8px 6px rgba(7,17,27,.1);
  &.isHidden {
    display: none;
  }
  &.isShow {
    display: flex;
    animation: cloakDisplay 1s 1;
  }
  .btn {
    font-size: 38px;
    position: absolute;
    top: 0;
    left: 20px;
  }
  .content {
    .img {
      width: 200px;
      img {
        width: 100%;
      } 
    }
    .word {
      margin-bottom: 30px;
      text-align: center;
    }
    .return-btn {
      margin: 0 auto;
      height: 34px; width: 103px;
      background: rgba(246,249,255,1);
      text-align: center;
      color: #1458D4;
      font-size: 16px;
      line-height: 34px;
      border-radius: 4px;
    }
  }
}
</style>
